class AuthService {

    isAuthenticated () {
        const accessToken = localStorage.getItem('accessToken')
        return (typeof accessToken !== "undefined" && accessToken !== null && accessToken !== '')
    }

}

export default new AuthService()
